// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"1e4dd33a","612":"1e4dd33a","618":"1e4dd33a","828":"1e4dd33a"}[chunkId] + ".chunk.css";
};